var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.html)?_c('div',{staticClass:"rpl-markup tide-wysiwyg app-wysiwyg"},[_c({ template: _vm.getTemplate.html, data: function () { return _vm.getTemplate.data; } },{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }